import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PlaintextEditContainer.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';

import PageStack from '../../Tabbing/PageStack';
import "../../Tabbing/PageStack";
import HtmlEditor from '../HtmlEditor';
import ("../HtmlEditor");
import lang from 'dojo/_base/lang';


class PlaintextEditContainer extends compose(_WidgetBaseSP) {
    templateString: any = template;

    plaintextInput: HTMLInputElement;
    htmlEditor: MdsLax<InstanceType<typeof HtmlEditor>>;
    editorPagestack: MdsLax<InstanceType<typeof PageStack>>;
    originalData: string;

    setValue(value: string, suppressChangeEvent?: boolean): void {

        this.originalData = value;
        var parsedData = this._removeScEditorTag(this.getContent(value));

        this.plaintextInput.value = parsedData;
        this.htmlEditor.setHtmlContent(parsedData, suppressChangeEvent);
    }

    deactivatePlaintextEditor(bDeactivateEditor: boolean): void {
        this.htmlEditor.show();
        this.editorPagestack.hidePage("plaintext", bDeactivateEditor);
        this.editorPagestack.hideTabRow(bDeactivateEditor);
        //this.editorPagestack.activatePageByName("html");
        
    }

    private getContent(value: string): string {
        var regex = /<body>(\s|\S)*<\/body>/g;
        var result = regex.exec(value);

        if (result?.length > 0) {
            var newValue = result[0].replace(/<body>|<\/body>/g, "");
            return newValue;
        } else {
            return value;
        }
    }

    private setContent(value: string): void {
        var regex = /<body>(\s|\S)*<\/body>/g;
        var result = regex.exec(this.originalData);
        if (result?.length > 0) {
            this.originalData = this.originalData.replace(result[0], `<body>${value}</body>`);
        } else {
            this.originalData = value;
        }
        this.originalData = this.originalData.replace("class=\"sceditor-nlf\"", "");
    }

    getValue(): string {
        return this.originalData;
    }

    getValueBase64(): string {
        return btoa(encodeURI(this.originalData));
    }

    private _onClickCancelButton(e: Event): void {
        this.emit("cancel");
    }

    private _onClickOkButton(e: Event): void {
        this.emit("ok", this.getValue());
    }

    private _onInputMessageInput(e: Event): void {
        var element = e.target as HTMLInputElement;
        element.style.height = "1em";
        element.style.height = (element.scrollHeight) + "px";
    }



    private _onPageChange(pageName: string): void {
        if (pageName === "html") {
            this.htmlEditor.close();
            this.htmlEditor.SCEditor_reload(true);
            if (this.htmlEditor.flagEditorExistsInDom) {
                
                //this.htmlEditor.SCEditor_reload();
            } else {
                //this.htmlEditor.show();
            }
        } else {
            this.htmlEditor.close();
        }
    }

    private _removeScEditorTag(content: string): string {
        if (content) return content.replace("class=\"sceditor-nlf\"", "");
        return "";
    }

    private keydownTimeout: boolean;
    private _onPlaintextKeydown(e: Event) {
        if (!this.keydownTimeout) {
            this.keydownTimeout = true
            setTimeout(lang.hitch(this, this._onPlaintextChange), 1500);
        }
    }


    private _onPlaintextChange(e: Event) {
        this.keydownTimeout = false;

        var plainTextValue = this._removeScEditorTag(this.plaintextInput.value);
        this.htmlEditor.setHtmlContent(plainTextValue, true);
        this.setContent(plainTextValue);
        this.emit("change");
    }

    private _onHtmlChange(value: string) {

        var inputValue = this._removeScEditorTag(this.htmlEditor.getScVal())
        var inputValue = this._cleanUpHTMLData(inputValue);

        this.plaintextInput.value = inputValue;
        this.setContent(inputValue);
        this.emit("change");
    }

    private _cleanUpHTMLData(value: string): string {
        let cleanData = value.replace(/<p><br><\/p>/g, "<br>");
        cleanData = cleanData.replace(/<p><font/g, "<font");
        cleanData = cleanData.replace(/<\/font><\/p>/g, "</font>");
        cleanData = cleanData.replace(/(<p>)/g, "");
        cleanData = cleanData.replace(/(<\/p>)/g, "<br>");
        cleanData = "<p>" + cleanData + "</p>";


        return cleanData;
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);


        this.editorPagestack.on("pageChange", lang.hitch(this, this._onPageChange));
        this.plaintextInput.addEventListener("change", lang.hitch(this, this._onPlaintextChange));
        this.plaintextInput.addEventListener("keydown", lang.hitch(this, this._onPlaintextKeydown));
        //this.plaintextInput.addEventListener("input", lang.hitch(this, this._onInputMessageInput));
        //this.plaintextInput.on("change", lang.hitch(this, this._onPlaintextChange));
        this.htmlEditor.on("valueChange", lang.hitch(this, this._onHtmlChange));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(PlaintextEditContainer);